import React from "react";
import { useMsal } from "@azure/msal-react";
import { FormikProvider, useFormik } from "formik";
import { VrsButton } from "@veris-health/web-core";
import * as yup from "yup";
import { VrsFormInputField } from "../../../ui/components/VrsFormInputField";
import { setAccessToken } from "../../shared/slices/authSlice";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { SCOPES } from "../../../ssoConfig";
import { emailValidation } from "../../../utils/validations";

const validationSchema = yup.object().shape({
  email: emailValidation,
});

export default function SSOLogin() {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: { email: "" },
    initialErrors: { email: "Email is required" },
    validationSchema,
    onSubmit: async (values, helpers) => {
      try {
        const loginResponse = await instance.loginPopup({
          scopes: [...SCOPES],
          loginHint: values.email,
          prompt: "login",
          extraQueryParameters: { login_hint: values.email },
        });

        const account = loginResponse.account || instance.getActiveAccount() || null;
        if (account) instance.setActiveAccount(account);

        let tokenResponse;
        try {
          tokenResponse = await instance.acquireTokenSilent({
            account,
            scopes: [...SCOPES],
          });
        } catch (e: any) {
          if (e?.errorCode === "interaction_required") {
            tokenResponse = await instance.acquireTokenPopup({
              scopes: [...SCOPES],
              loginHint: values.email,
              prompt: "login",
            });
          } else {
            throw e;
          }
        }

        const { accessToken } = tokenResponse;

        dispatch(setAccessToken(accessToken));
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        helpers.setSubmitting(false);
      }
    },
    // validateOnMount: true,
  });

  return (
    <div
      style={{
        borderLeft: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        padding: "2rem",
        gap: "1rem",
      }}
    >
      <div>
        <h3 style={{ margin: "0" }}>Single Sign On</h3>
        <h3 style={{ margin: "0" }}>(SSO)</h3>
      </div>

      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit} noValidate>
          <VrsFormInputField
            name="email"
            type="text"
            label="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            placeholder="Email"
            error={false}
          />

          <VrsButton
            style={{ marginTop: "1rem" }}
            buttonType="primary"
            type="submit"
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Sign in
          </VrsButton>
        </form>
      </FormikProvider>
    </div>
  );
}
